import { useContext } from 'react';
import useChat from './useChat';
import ChatDrawerView from './ChatDrawerView';
import { ChatControllerContext } from './ChatControllerContext';

/**
 * ChatDrawer — clinical chat with Elis.
 *
 * Resolves which controller drives the shared <ChatDrawerView/>:
 *   - if a controller is injected via ChatControllerContext (the demo route), use it;
 *   - otherwise use the production useChat() controller (unchanged behavior).
 *
 * The conditional picks a different child COMPONENT (not a conditional hook), so the
 * Rules of Hooks are respected and useChat never runs on the demo route (no network).
 *
 * Props:
 *   patientId / patientName / isOpen / onToggle / fullscreen / onFullscreenToggle / refreshUserFiles
 */
function ProdChatDrawer({ patientId = null, patientName, isOpen, onToggle, fullscreen, onFullscreenToggle, refreshUserFiles }) {
  const controller = useChat({ patientId, refreshUserFiles });
  return (
    <ChatDrawerView
      controller={controller}
      isOpen={isOpen}
      onToggle={onToggle}
      fullscreen={fullscreen}
      onFullscreenToggle={onFullscreenToggle}
      patientName={patientName}
    />
  );
}

export default function ChatDrawer(props) {
  const injected = useContext(ChatControllerContext);
  if (injected) {
    const { isOpen, onToggle, fullscreen, onFullscreenToggle, patientName } = props;
    return (
      <ChatDrawerView
        controller={injected}
        isOpen={isOpen}
        onToggle={onToggle}
        fullscreen={fullscreen}
        onFullscreenToggle={onFullscreenToggle}
        patientName={patientName}
      />
    );
  }
  return <ProdChatDrawer {...props} />;
}
